import React from "react";

type ModalSize = "default" | "small";

interface ModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  titleId?: string;
  size?: ModalSize;
  children: React.ReactNode;
}

export default function Modal({
  show,
  onClose,
  title,
  titleId,
  size = "default",
  children,
}: ModalProps) {
  if(show) {
    document.body.classList.add("overflowHidden");
  } else {
    document.body.classList.remove("overflowHidden");
  }
  const isSmall = size === "small";
  const descriptionClass = isSmall
    ? "w-full mx-auto bg-neutral-white rounded-t md:rounded p-6 md:p-8"
    : "content-assumption-description";
  // Tailwind in this project only scans HTML templates, so arbitrary
  // values like md:max-w-[520px] are not in the compiled CSS. Use an
  // inline style to cap the small modal width reliably.
  const descriptionStyle = isSmall ? { maxWidth: "520px" } : undefined;
  return (
    <div className={`modal${show ? " open" : ""}`}>
      <div className="content-modal-assumption">
        <div className={descriptionClass} style={descriptionStyle}>
          <div className="flex items-center justify-between border-b border-gray-10 pb-4 mb-6">
            <h5
              id={titleId}
              className="lead text-primary-100 font-semibold pr-4"
            >
              {title}
            </h5>
            <button
              onClick={onClose}
              className="btn-icon btn-primary btn-small"
            >
              {" "}
              <i className="icon icon-close text-[10px]"></i>
            </button>
          </div>
          <div className="block space-y-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
